import { Logger } from './services/Logger';
import { SentryLogAdapter } from './services/Sentry';
import { addDefaultAdapters } from './services/Tracking';

export function onClientEntry() {
  Logger.addAdapter(SentryLogAdapter);
  addDefaultAdapters();
}
